import { MainScreen } from './ui/screens/MainScreen'

export function App() {
  return <MainScreen />
}
